import { config } from "../config";

const queryParams = new URLSearchParams(location.search);
const storeUriUiParam = queryParams.get("storeUriUi");

export const storeUriUi = storeUriUiParam ? storeUriUiParam : config.elrond.ui;
